// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type PosPaths = paths;
export const POS_SERVICE = "pos" as const;

/** Typed openapi-fetch client for the pos service (schema `pos`). */
export function createPosClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("pos", options);
}

export type PosClient = ReturnType<typeof createPosClient>;
